import Compensation from './Compensation'

export default Compensation